import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'longmoon-atmosphere',
  templateUrl: './atmosphere.component.html',
  styleUrls: ['./atmosphere.component.scss']
})
export class AtmosphereComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
